<template>
  <!-- 新增分组弹窗 -->
  <div class="vmp-group-add">
    <vh-dialog
      :visible="dialogVisible"
      @open="handlOpen"
      :before-close="handleClose"
      :close-on-click-modal="false"
      width="400px"
      :title="$t('host.k_549001')"
    >
      <vh-form class="add-form">
        <vh-form-item :label="$t('host.k_549002')" labvh-width="40px">
          <vh-input
            :placeholder="placeholder"
            v-model.trim.number="count"
            onkeyup="this.value=this.value.replace(/[^\d]/g,'')"
          >
            <template slot="suffix">{{ $t('host.k_549003') }}</template>
          </vh-input>
        </vh-form-item>
      </vh-form>

      <!-- 底部按钮 -->
      <div slot="footer" class="vmp-group-ft">
        <vh-button plain type="info" :round="true" @click="handleClose">
          {{ $t('host.k_549004') }}
        </vh-button>
        <vh-button type="primary" :round="true" @click="handleThrottleSubmit()">
          {{ $t('host.k_549005') }}
        </vh-button>
      </div>
    </vh-dialog>
  </div>
</template>
<script>
  import { useGroupServer, useRoomBaseServer } from 'middle-domain';
  import { throttle } from 'lodash';

  export default {
    name: 'VmpGroupAdd',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        dialogVisible: this.show,
        count: 1
      };
    },
    beforeCreate() {
      this.groupServer = useGroupServer();
      this.roomBaseServer = useRoomBaseServer();
    },
    computed: {
      placeholder() {
        return this.$t('host.k_549006', [50 - this.groupServer.state.groupedUserList.length]);
      }
    },
    watch: {
      show: function (newVal) {
        this.dialogVisible = newVal;
      }
    },
    mounted() {
      this.handleThrottleSubmit = throttle(this.handleSubmit, 300, { trailing: false });
    },
    methods: {
      // 新增分组确定
      handleSubmit: async function () {
        const c = parseInt(this.count);
        if (isNaN(c) || c < 1) {
          this.$message.warning(this.$t('host.k_549007'));
          return false;
        }
        const { watchInitData = {} } = this.roomBaseServer.state;
        try {
          const result = await this.groupServer.groupCreate({
            number: c,
            way: 2,
            switch_id: watchInitData.switch.switch_id,
            webinar_id: watchInitData.webinar.id
          });
          if (result && result.code === 200) {
            this.count = 1;
            this.handleClose();
          } else {
            this.$message.warning(result.msg || this.$t('host.k_549008'));
          }
        } catch (ex) {
          this.$message.warning(ex.messge || this.$t('host.k_549009'));
        }
      },
      handlOpen() {
        // this.placeholder = `最多新增$组`,
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit('update:show', false);
      }
    }
  };
</script>
<style lang="less">
  .vmp-group-add {
    .vh-dialog__body {
      min-height: 32px !important;
    }

    .add-form {
      .vh-form-item {
        margin-bottom: 0px;
        .vh-form-item__label {
          color: #1a1a1a;
          font-weight: 400;
        }
        .vh-form-item__content {
          margin-left: 40px;

          .vh-input__suffix-inner {
            color: #666;
            padding: 2px 8px;
          }
        }
      }
    }
  }
</style>
